"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_components_2 = require("@desygner/ui-common-components");
const Button_1 = require("../Button");
const Slider_styles_1 = require("./Slider.styles");
function Slider({ icon, id, value: initialValue = 0, maxValue: max = 100, minValue: min = 0, name, onUpdate, onUpdateEnd, title, variant = 'default', }) {
    const theme = (0, ui_common_components_2.useTheme)();
    const [minValue, setMinValue] = (0, react_1.useState)(min);
    const [maxValue, setMaxValue] = (0, react_1.useState)(max);
    const [value, setValue] = (0, react_1.useState)(initialValue);
    (0, react_1.useEffect)(function updateValuesWhenPropChanges() {
        setMinValue(min);
        setMaxValue(max);
        setValue(initialValue);
    }, [initialValue, max, min]);
    const handleOnChange = (0, react_1.useCallback)((data) => {
        const value = Number(data);
        setValue(value);
        onUpdate(value);
    }, [setValue, onUpdate]);
    const handleOnMouseUp = (0, react_1.useCallback)((event) => {
        onUpdateEnd === null || onUpdateEnd === void 0 ? void 0 : onUpdateEnd({
            event,
            value,
        });
    }, [onUpdateEnd, value]);
    switch (variant) {
        case 'section':
            return ((0, jsx_runtime_1.jsxs)(Slider_styles_1.StyledContent, { variant: variant, children: [(0, jsx_runtime_1.jsx)(Slider_styles_1.StyledTitle, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { id: id, name: name || id, min: minValue, max: maxValue, size: "Small", value: value, type: "number", onChange: handleOnChange }) }), (0, jsx_runtime_1.jsx)(Slider_styles_1.StyledInputWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Slider, { min: minValue, max: maxValue, value: value, onChange: handleOnChange, onChangeEnd: handleOnMouseUp }) })] }));
        default:
            return ((0, jsx_runtime_1.jsx)(ui_common_components_1.DropdownNext, { options: [
                    {
                        type: 'custom',
                        value: 'slider',
                        children: ((0, jsx_runtime_1.jsxs)(Slider_styles_1.StyledContent, { variant: variant, children: [(0, jsx_runtime_1.jsxs)(Slider_styles_1.StyledTitle, { children: [variant === 'default' && ((0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { color: theme.Color.Neutrals.Dark, size: "Body", children: title })), (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { id: id, name: name || id, min: minValue, max: maxValue, size: "Small", value: value, type: "number", onChange: handleOnChange })] }), (0, jsx_runtime_1.jsx)(Slider_styles_1.StyledInputWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Slider, { min: minValue, max: maxValue, value: value, onChange: handleOnChange, onChangeEnd: handleOnMouseUp }) })] })),
                    },
                ], placement: "bottom", trigger: "click", children: (0, jsx_runtime_1.jsx)(Button_1.Button, { icon: icon, title: title, variant: "tooltip", onClick: (event) => event && event.preventDefault() }) }));
    }
}
exports.Slider = Slider;
//# sourceMappingURL=Slider.js.map